/**
 * Часть текущего адреса, которую нужно сохранить при переезде на поддомен
 * другого города. `window.location` структурно подходит под этот интерфейс.
 */
export interface CurrentLocationParts {
  protocol: string;
  pathname: string;
  search: string;
  hash: string;
}

/**
 * Строит адрес для перехода на поддомен выбранного города, сохраняя страницу,
 * на которой сейчас находится пользователь (path + query + hash).
 *
 * Хост (origin) берётся из `cityUrl`, а путь/параметры/якорь — из текущего
 * адреса `current`. Протокол-относительный `cityUrl` (вида `//city.example/`)
 * наследует протокол текущей страницы.
 *
 * При некорректном `cityUrl` возвращает его как есть (не бросает исключение).
 */
export function buildCityUrl(cityUrl: string, current: CurrentLocationParts): string {
  const path = `${current.pathname}${current.search}${current.hash}`;
  try {
    const target = new URL(cityUrl, `${current.protocol}//host`);
    return `${target.protocol}//${target.host}${path}`;
  } catch {
    return cityUrl;
  }
}
